import { ButtonBase, Stack, useTheme } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	hasDivider: boolean;
	onClick?: () => void;
};

export const SolutionRow: FC<Props> = ({ hasDivider, onClick, children }) => {
	const theme = useTheme();

	return (
		<Stack
			{...(onClick ? { component: ButtonBase, onClick } : {})}
			direction="row"
			alignItems="center"
			justifyContent="flex-start"
			textAlign="left"
			width="100%"
			gap={1.2}
			px={1.6}
			py={1.2}
			borderBottom={hasDivider ? 1 : 0}
			borderColor="divider"
		>
			{children}
			{onClick && (
				<MoreHorizontal
					size={theme.iconSize.sm}
					color={theme.palette.grey[400]}
				/>
			)}
		</Stack>
	);
};
